// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import places from './places.svg';

interface PlacesIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: PlacesNames;
}

export function PlacesIcon({ name, ...props }: PlacesIconProps) {
  return <Icon {...props} link={places} name={name} />
}

type PlacesNames =
  | 'ac_unit'
  | 'airport_shuttle'
  | 'all_inclusive'
  | 'apartment'
  | 'baby_changing_station'
  | 'backpack'
  | 'balcony'
  | 'bathtub'
  | 'beach_access'
  | 'bento'
  | 'bungalow'
  | 'business_center'
  | 'cabin'
  | 'carpenter'
  | 'casino'
  | 'chalet'
  | 'charging_station'
  | 'checkroom'
  | 'child_care'
  | 'child_friendly'
  | 'corporate_fare'
  | 'cottage'
  | 'countertops'
  | 'crib'
  | 'desk'
  | 'do_not_step'
  | 'do_not_touch'
  | 'dry'
  | 'elevator'
  | 'escalator_warning'
  | 'escalator'
  | 'family_restroom'
  | 'fence'
  | 'fire_extinguisher'
  | 'fitness_center'
  | 'food_bank'
  | 'foundation'
  | 'free_breakfast'
  | 'gite'
  | 'golf_course'
  | 'grass'
  | 'holiday_village'
  | 'hot_tub'
  | 'house_siding'
  | 'house'
  | 'houseboat'
  | 'iron'
  | 'kitchen'
  | 'meeting_room'
  | 'microwave'
  | 'night_shelter'
  | 'no_backpack'
  | 'no_cell'
  | 'no_drinks'
  | 'no_flash'
  | 'no_food'
  | 'no_meeting_room'
  | 'no_photography'
  | 'no_stroller'
  | 'other_houses'
  | 'pool'
  | 'rice_bowl'
  | 'roofing'
  | 'room_preferences'
  | 'room_service'
  | 'rv_hookup'
  | 'smoke_free'
  | 'smoking_rooms'
  | 'soap'
  | 'spa'
  | 'sports_bar'
  | 'stairs'
  | 'storefront'
  | 'stroller'
  | 'tapas'
  | 'tty'
  | 'umbrella'
  | 'vape_free'
  | 'vaping_rooms'
  | 'villa'
  | 'wash'
  | 'water_damage'
  | 'wheelchair_pickup'
;

